/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ChartColumnBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ChartColumnBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.ChartDataBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.ChartColumnBean);
  }
}(this, function(ApiClient, ChartColumnBean) {
  'use strict';

  /**
   * The ChartDataBean model module.
   * @module model/ChartDataBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ChartDataBean</code>.
   * @alias module:model/ChartDataBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>ChartDataBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChartDataBean} obj Optional instance to populate.
   * @return {module:model/ChartDataBean} The populated <code>ChartDataBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('columns'))
        obj.columns = ApiClient.convertToType(data['columns'], [ChartColumnBean]);
      if (data.hasOwnProperty('rows'))
        obj.rows = ApiClient.convertToType(data['rows'], 'String');
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/ChartColumnBean>} columns
   */
  exports.prototype.columns = undefined;

  /**
   * @member {String} rows
   */
  exports.prototype.rows = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/ChartDataBean.js